import { memo } from "react";
import { LoaderCircle } from "lucide-react";

import ThinkingDots from "@/features/tutor/components/ThinkingDots";

const TurnStatus = ({ label }: { label: string }) => (
  <span className="inline-flex min-h-[34px] items-center gap-2 rounded-[11px] border border-white/20 bg-white/[0.12] px-[11px] py-[7px] text-[15px] font-bold text-[#F5F7FA] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.04)]">
    <LoaderCircle size={17} strokeWidth={2.2} className="thinking-spin" />
    <span>{label}</span>
    <ThinkingDots className="ml-px gap-[3px]" />
  </span>
);

export default memo(TurnStatus);
